import { createFileRoute } from "@tanstack/react-router";
import { UserDiscoverPage } from "@/pages/user-discover/ui/user-discover-page";

const UserDiscoverRoute = () => {
  return <UserDiscoverPage />;
};

export const Route = createFileRoute("/_authed/discover")({
  component: UserDiscoverRoute,
});
